import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Card, InputLabel, TextField, withStyles, FormControlLabel, Checkbox } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import swal from '@sweetalert/with-react';
import { Auth } from 'aws-amplify';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import moment from 'moment';

import { EVENT_ID, EVENT_IMG } from '../constatns';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import FindID from './FindID';

const styles = (theme) => ({
  cardBox: { minWidth: 780 },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  inputLabel: {
    color: '#777',
    fontWeight: 'bold',
    marginBottom: '5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  formInput: {
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0',
    },
  },
  loginInfo: {
    fontSize: '1.1em',
    fontWeight: 700,
    lineHeight: 1.7,
    marginTop: 10,
    marginBottom: 20,
    color: '#777',
    '& span': {
      color: 'red',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      '& span': {
        fontSize: '8px',
      },
    },
  },
  submit: {
    fontSize: '1.1em',
    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 1),
    },
  },
});

class LoginPage extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      isSaveID: false,
      matches: window.matchMedia('(max-width:600px)').matches,

      isFindSelectOpen: false,
      isFindIdOpen: false,
    };

    this.refIDInput = React.createRef();
    this.refPWInput = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
    this.goSite = this.goSite.bind(this);
    this.changeSaveID = this.changeSaveID.bind(this);
  }

  componentDidMount() {
    //You are already logged in.
    if (sessionStorage.getItem('_in_user_') && sessionStorage.getItem('_in_jwt')) {
      swal('', 'You are already logged in.', 'warning').then(() => {
        this.props.history.push('/main');
      });
    }

    const evtTarget = document.getElementById('password');
    evtTarget.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        this.handleSignIn(event);
      }
    });

    if (this.props.cookies.get('userID')) {
      this.setState({ isSaveID: true, email: this.props.cookies.get('userID') });
    }
  }

  componentWillUnmount() {
    const evtTarget = document.getElementById('password');
    evtTarget.removeEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        this.handleSignIn(event);
      }
    });
  }

  goSite() {}

  saveIDCookie() {
    let momentDate = moment();
    // console.log(momentDate.add(90, 'd').format('LLLL'));

    if (this.state.isSaveID) {
      if (!this.props.cookies.get('userID')) {
        this.props.cookies.set('userID', this.state.email, { path: '/', expires: momentDate.add(180, 'd').toDate() });
      }
    } else {
      this.props.cookies.remove('userID');
    }
  }

  handleSignIn(event) {
    // console.log(this.state);
    event.preventDefault();

    const email = this.state.email.replace(/ /gi, '');
    let pwd = this.state.password.replace(/ /gi, '');

    if (email.length < 1) {
      swal('', 'Please enter your email(id).', 'warning').then(() => {
        this.refIDInput.current.focus();
      });
      return false;
    } else {
      this.saveIDCookie();
    }

    if (pwd.length < 1) {
      swal('', 'Please enter your password.', 'warning').then(() => {
        this.refPWInput.current.focus();
      });
      return false;
    }

    if (('' + this.state.password).length < 6) {
      pwd = this.state.password.padEnd(6, '0');
    }
    Auth.signIn(EVENT_ID + '_' + email, pwd)
      .then((user) => {
        // console.log(user);
        // console.log(user.signInUserSession.idToken);
        const idToken = user.signInUserSession.idToken;

        // localStorage.clear();
        sessionStorage.setItem('_in_user_', user.username);
        sessionStorage.setItem('_in_country', idToken.payload['custom:country']);
        sessionStorage.setItem('_in_jwt', idToken.getJwtToken());
        sessionStorage.setItem('_in_sub', user.attributes.sub);
        sessionStorage.setItem('_in_name', idToken.payload['custom:in_name']);
        sessionStorage.setItem('_in_event_id', idToken.payload['event_id']);
        sessionStorage.setItem('_in_role', idToken.payload['custom:role']);
        sessionStorage.setItem('_in_title', idToken.payload['custom:title']);
        sessionStorage.setItem('_in_license', idToken.payload['custom:license']);

        // login time log
        this.props.history.push('/mypage');
      })
      .catch((err) => {
        console.log(err);
        swal(err.message);
      });
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  changeSaveID(e) {
    this.setState({ isSaveID: e.target.checked });
  }

  handleState(key, value) {
    this.setState({ [key]: value });
  }

  closeFindSelectDialog() {
    this.setState({ isFindSelectOpen: false });
  }

  closeFindIDDialog() {
    this.setState({ isFindIdOpen: false });
  }

  render() {
    const { classes, theme } = this.props;
    return (
      <div>
        <CssBaseline />
        {/* <Topbar MIdx={6} SIdx={5} /> */}
        <Topbar MIdx={6} SIdx={3} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Personal Information</MainTitle>
            </Grid>
            <Grid item xs={8} style={{ margin: theme.spacing(2, 0) }}>
              <Grid container justifyContent={'center'}>
                <Card className={classes.cardBox} variant="outlined" square>
                  <div style={{ padding: '0 100px' }}>
                    <Typography
                      style={{
                        color: theme.palette.primary.main,
                        fontWeight: 'bold',
                        fontSize: '2.5em',
                        textAlign: 'center',
                        paddingTop: '60px',
                      }}
                    >
                      LOGIN
                    </Typography>
                    <Typography variant="subtitle1" className={classes.loginInfo}>
                      Once you complete the Sign-up, please enter your ID (E-mail) and Password.
                    </Typography>
                    <form className={classes.form} noValidate onSubmit={this.handleSignIn}>
                      <Grid container justifyContent="space-between">
                        <Grid item xs={9}>
                          <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '15px' }}>
                            <InputLabel htmlFor="email" className={classes.inputLabel}>
                              ID(E-mail)
                            </InputLabel>
                            <TextField
                              required
                              fullWidth
                              variant="outlined"
                              id="email"
                              type="email"
                              size="small"
                              autoFocus
                              onChange={(e) => {
                                this.handleChange('email', e);
                              }}
                              value={this.state.email}
                              className={classes.formInput}
                              inputRef={this.refIDInput}
                            />
                          </Grid>
                          <Grid container justifyContent="space-between" alignItems="center">
                            <InputLabel htmlFor="email" className={classes.inputLabel}>
                              Password
                            </InputLabel>
                            <TextField
                              required
                              fullWidth
                              variant="outlined"
                              size="small"
                              id="password"
                              type="password"
                              name="password"
                              onChange={(e) => {
                                this.handleChange('password', e);
                              }}
                              value={this.state.password}
                              className={classes.formInput}
                              inputRef={this.refPWInput}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          style={{
                            fontWeight: 'bold',
                            paddingLeft: '30px',
                          }}
                        >
                          <Button
                            color="primary"
                            variant="contained"
                            disableElevation
                            style={{ borderRadius: '5px', width: '100%', height: '100%', fontSize: 'large', fontWeight: 'bold' }}
                            onClick={this.handleSignIn}
                          >
                            Login
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid container justifyContent="flex-end" style={{ paddingBottom: '30px' }}>
                        <FormControlLabel
                          control={
                            <Checkbox size="small" color="primary" checked={this.state.isSaveID} onChange={(e) => this.changeSaveID(e)} />
                          }
                          label={<span style={{ color: '#aaa', fontSize: '0.9em' }}>Save my ID (E-mail)</span>}
                        />
                      </Grid>
                      <div style={{ borderTop: '1px solid #eee', padding: '30px 0' }}>
                        <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '10px' }}>
                          <span style={{ color: '#999' }}>- Forgotten your ID?</span>{' '}
                          <Button
                            color="secondary"
                            variant="outlined"
                            disableElevation
                            onClick={() => this.setState({ isFindSelectOpen: true })}
                            style={{ width: '30%', fontWeight: 'bold', border: '2px solid' }}
                          >
                            Find ID
                          </Button>
                        </Grid>
                        <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '10px' }}>
                          <span style={{ color: '#999' }}>- Forgotten your password?</span>{' '}
                          <Button
                            color="secondary"
                            variant="outlined"
                            disableElevation
                            onClick={() => this.props.history.push('/findpw')}
                            style={{ width: '30%', fontWeight: 'bold', border: '2px solid' }}
                          >
                            Find Password
                          </Button>
                        </Grid>
                        <Grid container justifyContent="space-between" alignItems="center">
                          <span style={{ color: '#999' }}>- Please sign up if this is your first visit.</span>
                          <Button
                            color="secondary"
                            variant="outlined"
                            disableElevation
                            onClick={() => this.props.history.push('/choose')}
                            style={{ width: '30%', fontWeight: 'bold', border: '2px solid' }}
                          >
                            Sign Up
                          </Button>
                        </Grid>
                      </div>
                    </form>
                  </div>
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    style={{
                      backgroundColor: '#F3F6F8',
                      // padding: '30px 100px'
                      padding: '30px 60px',
                    }}
                  >
                    <img src={`${EVENT_IMG}/sound.png`} alt="sound icon" style={{ height: '85px', width: '85px' }} />
                    <Typography variant="subtitle1" className={classes.loginInfo}>
                      * Please sign up if you are not registered as a user.
                      <br />
                      *&nbsp;
                      <span style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
                        Registration, Free paper and Speaker abstract submission
                      </span>
                      <br />
                      &nbsp;&nbsp;will be available after sign-up.
                      <br />* PRS KOREA 2022 참가를 위해 새로운 ID와 PW를 만들어 주시기 바랍니다.
                      <br />* Sign-up 후&nbsp;
                      <span style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>사전등록</span> 및&nbsp;
                      <span style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>초록접수</span>가 가능합니다.
                    </Typography>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
        <FindID
          handleState={this.handleState.bind(this)}
          selectopen={this.state.isFindSelectOpen}
          selectclose={this.closeFindSelectDialog.bind(this)}
          idopen={this.state.isFindIdOpen}
          idclose={this.closeFindIDDialog.bind(this)}
        />
      </div>
    );
  }
}

export default withCookies(withStyles(styles, { withTheme: true })(LoginPage));
